import React from "react";
import PropTypes from "prop-types";
import { Select, Form } from "antd";

const { Option } = Select;

function Cell(props) {
  // console.log(props,'cell props')
  return (
    <Select
      value={props.value}
      placeholder="Please Select"
      allowClear={true}
      style={props.style ? props.style : { width: 250 }}
      showSearch
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      onChange={(e) => {
        if (props.type !== undefined) {
          props.updateDataRecord(props.elem.uniqueId, props.type, e);
        } else {
          props.updateDataRecord(props.index, props._id, e);
        }
      }}
    >
      {props.list.map((el) => (
        <Option key={el._id} value={el._id}>
          {el.name}
        </Option>
      ))}
    </Select>
    // <span>cell {props.name}</span>
  );
}

// Cell.propTypes = {

// }

export default Cell;
